import CloseIcon from '@material-ui/icons/Close';
import {
    Box,
    Dialog,
    DialogContent,
    IconButton,
    Typography
} from "@mui/material";

import { useTheme } from "@mui/material";
// import imagePlaceholder from '../../assets/img/image_placeholder.jpg';
import { useState } from 'react';
import TestAssign1 from '../../assets/img/TestCreation/TestAssign1.png';
import TestAssign2 from '../../assets/img/TestCreation/TestAssign2.png';
import TSchedule1 from '../../assets/img/TestCreation/TSchedule1.png';
import TSchedule2 from '../../assets/img/TestCreation/TSchedule2.png';
import TSchedule3 from '../../assets/img/TestCreation/TSchedule3.png';




const steps = [
    {
        title: "Navigate to the Tests",
        description: [
            "From the Dashboard, click on the Tests tab.",
            "OR go to Manage Tests and select the Tests option.",
            "Select the Test to assign, In the Actions Column, Click the Assign button.",

        ],
        image: TestAssign1,
    },
    {

        title: "Assign Students ",
        description: [
            "select students from the Available list section, Click the ‘Assign Student’ button That’s it! The test is now assigned to students!",
        ],
        image: TestAssign2,
    },

    // 
    {
        mainTitle: "Schedule Test",
        title: "Navigate to the Tests",
        description: [
            "From the Dashboard, click on the Tests tab.",
            "OR go to Manage Tests and select the Tests option.",
            "Select the Test to schedule, In the Actions Column, Click the Schedule button."
        ],
        image: TSchedule1,
    },
    {
        title: "Schedule Immediately",
        description: [
            "Select the Now option to start the test immediately.",
        ],
        image: TSchedule2,
    },
    {
        title: "Schedule Later",
        description: [
            "Choose a future date and time to schedule the test later.",
        ],
        image: TSchedule3,
    },
];

function AssignTestToStudents() {
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const handleImageClick = (imgSrc) => {
        setSelectedImage(imgSrc);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedImage(null);
    };
    return (
        <Box maxWidth="md" mx="auto" p={4}>
            <Typography variant="h5" gutterBottom>
                Assigned Test to Students
            </Typography>

            {steps.map((step, index) => (
                <Box
                    key={index}
                    display="flex"
                    flexDirection={index % 2 === 0 ? "row" : "row-reverse"}
                    alignItems="center"
                    my={5}
                    gap={4}
                    flexWrap="wrap"
                >
                    <Box
                        component="img"
                        src={step?.image}
                        alt={`Step ${index + 1}`}
                        onClick={() => handleImageClick(step.image)}
                        sx={{
                            width: { xs: "100%", sm: "25%" },
                            borderRadius: 2,
                            boxShadow: 3,
                            visibility: step.image ? 'visible' : 'hidden',
                            cursor: "pointer",
                            transition: "transform 0.2s",
                            "&:hover": {
                                transform: "scale(1.05)",
                            },
                        }}
                    />
                    <Box flex="1" minWidth="250px">
                        {step?.mainTitle && <Typography variant="h6" sx={{ color: '#e63573', textTransform: 'none' }}>{step.mainTitle}</Typography>}
                        <Typography variant="body1" sx={{ textTransform: 'none', fontWeight: 'bold' }}>{step.title}</Typography>
                        <ul>
                            {step.description.map((item, idx) => (
                                <li key={idx}>
                                    <Typography variant="body1">{item}</Typography>
                                </li>
                            ))}
                        </ul>
                    </Box>
                </Box>
            ))}
            {/* Dialog for Image Popup */}
            <Dialog open={open} onClose={handleClose} maxWidth="md">
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        zIndex: 1,
                        color: "grey.500",
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    {selectedImage && (
                        <Box
                            component="img"
                            src={selectedImage}
                            alt="Popup Preview"
                            sx={{
                                width: "100%",
                                height: "auto",
                                borderRadius: 2,
                                boxShadow: 3,
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </Box>
    );
}

export default AssignTestToStudents;
